import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IPinterestProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
  type?: string;
  boardWidth?: string;
  scaleHeight?: string;
  scaleWidth?: string;
}

export default function Pinterest({
  className,
  href,
  type = 'embedUser',
  boardWidth = '150',
  scaleWidth = '60',
  scaleHeight = '800',
}: IPinterestProps): React.ReactElement {
  const bem = bemBlock('pinterest');
  const blockClasses = classnames([bem(), className]);
  return (
    <a
      className={blockClasses}
      href={href}
      data-pin-do={type}
      data-pin-board-width={boardWidth}
      data-pin-scale-width={scaleWidth}
      data-pin-scale-height={scaleHeight}
    />
  );
}
